import { matchPath } from "./matchPath.js";
import { asyncCheckIf } from "./compute/checkIf.js";
import { hooks } from "./Runtime.js";
export async function matchRoutes(routes, runtimeContext) {
  for (const route of routes) {
    if (typeof route.path !== "string") {
      // eslint-disable-next-line no-console
      console.error("Invalid route with invalid path:", route);
      throw new Error(`Invalid route with invalid type of path: ${typeof route.path}`);
    }
    const match = matchRoute(route, runtimeContext.app.homepage, runtimeContext.location.pathname);
    if (match && (await asyncCheckIf(route, runtimeContext))) {
      if (runtimeContext.app.noAuthGuard || route.public || !(hooks !== null && hooks !== void 0 && hooks.auth) || hooks.auth.isLoggedIn()) {
        return {
          match,
          route
        };
      }
      return "unauthenticated";
    }
  }
  return "missed";
}
export function matchRoute(route, homepage, pathname) {
  const routePath = route.path.replace(/^\$\{APP.homepage\}/, homepage);
  return matchPath(pathname, {
    path: routePath,
    exact: route.exact
  });
}
//# sourceMappingURL=matchRoutes.js.map